<template>
  <div class="animated fadeIn" v-if="eib_info">
    <div class="row" v-if="eib_info">
      <div class="col-lg-12">
        <div class="m-t-lg">
          <h1 v-if="eib_info.counterpart_name">
            {{ eib_info.counterpart_name }}
          </h1>
          <h1 v-else-if="eib_info.buyer_name_orig">
            {{ eib_info.buyer_name_orig }}
          </h1>
          <h1 v-else="eib_info.winner_name_orig">
            {{ eib_info.winner_name_orig }}
          </h1>
          <br />
        </div>
      </div>
    </div>
    <div class="row" v-if="eib_info">
      <div class="col-lg-6">
        <div class="m-t-lg">
          <h1 v-if="eib_info.dedup_id_buyer">
            <span class="badge badge-dark"> Buyer </span>
          </h1>
          <h1 v-else><span class="badge badge-dark"> Bidder </span></h1>
          <br />
        </div>
      </div>
    </div>
    <div class="row charts justify-content-between flex-nowrap" v-if="eib_info">
      <div class="bar-chart">
        <h2>CRI EIB Score</h2>
        <hr />
        <div class="bar-chart-wrapper" v-if="isLoading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="bar-chart-wrapper" v-else>
          <canvas id="Gauge1"></canvas>
          <h2 style="text-align: center">{{ global_gauge.cri_eib }}</h2>
        </div>
      </div>
      <div class="bar-chart">
        <h2 v-if="eib_info.dedup_id_buyer">Average Buyer Score</h2>
        <h2 v-else>Average Bidder Score</h2>
        <hr />
        <div class="bar-chart-wrapper" v-if="isLoading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="bar-chart-wrapper" v-else>
          <canvas id="Gauge2"></canvas>
          <h2 style="text-align: center">{{ global_gauge.avg }}</h2>
        </div>
      </div>
      <div class="bar-chart">
        <h2 v-if="eib_info.counterpart_country_name">
          {{ eib_info.counterpart_country_name }} Score
        </h2>
        <h2 v-else-if="eib_info.COUNTRY_BUYER">
          {{ eib_info.COUNTRY_BUYER }} Score
        </h2>
        <h2 v-else="eib_info.COUNTRY_BIDDER">
          {{ eib_info.COUNTRY_BIDDER }} Score
        </h2>
        <hr />
        <div class="bar-chart-wrapper" v-if="isLoading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="bar-chart-wrapper" v-else>
          <canvas id="Gauge3"></canvas>
          <h2 style="text-align: center">{{ global_gauge.country }}</h2>
        </div>
      </div>
      <div class="bar-chart">
        <h2>{{ sector_gauge_1.sector }} Score</h2>
        <hr />
        <div class="bar-chart-wrapper" v-if="isLoading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="bar-chart-wrapper" v-else>
          <canvas id="Gauge4"></canvas>
          <h2 style="text-align: center">{{ sector_gauge_1.cpv }}</h2>
        </div>
      </div>
      <div class="bar-chart">
        <h2 v-if="eib_info.counterpart_country_name">
          {{ sector_gauge_1.sector }}/ {{ eib_info.counterpart_country_name }}
          Score
        </h2>
        <h2 v-else-if="eib_info.COUNTRY_BUYER">
          {{ sector_gauge_1.sector }} / {{ eib_info.COUNTRY_BUYER }} Score
        </h2>
        <h2 v-else="eib_info.COUNTRY_BIDDER">
          {{ sector_gauge_1.sector }} / {{ eib_info.COUNTRY_BIDDER }} Score
        </h2>
        <hr />
        <div class="bar-chart-wrapper" v-if="isLoading">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="bar-chart-wrapper" v-else>
          <canvas id="Gauge5"></canvas>
          <h2 style="text-align: center">{{ sector_gauge_2.cpv_country || sector_gauge_2.cpv }}</h2>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-6 col-lg-6" v-if="eib_info.counterpart_name">
        <div class="card">
          <div class="card-header bg-transparent">
            Information
            <hr />
          </div>
          <div class="card-body">
            <p>&nbsp;</p>
            <p>Name : {{ eib_info.counterpart_name }}</p>
            <p>Address : {{ eib_info.counterpart_street_address }}</p>
            <p>Town : {{ eib_info.counterpart_postal_address }}</p>
            <p>Country : {{ eib_info.counterpart_country_name }}</p>
            <p>Legal Form : {{ eib_info.counterpart_legal_form }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6" v-else-if="eib_info.buyer_name_orig">
        <div class="card">
          <div class="card-header bg-transparent">
            Information
            <hr />
          </div>
          <div class="card-body">
            <p>&nbsp;</p>
            <p>Name : {{ eib_info.buyer_name_orig }}</p>
            <p>Address : {{ eib_info.ADDRESS_BUYER }}</p>
            <p>Town : {{ eib_info.POSTAL_ADDRESS_BUYER }}</p>
            <p>Country : {{ eib_info.COUNTRY_BUYER }}</p>
            <p>Legal Form : {{ eib_info.AA_AUTHORITY_TYPE }}</p>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>
      <div class="col-xl-6 col-lg-6" v-else>
        <div class="card">
          <div class="card-header bg-transparent">Information</div>
          <div class="card-body">
            <p>&nbsp;</p>
            <p>Name : {{ eib_info.winner_name_orig }}</p>
            <p>Address : {{ eib_info.ADDRESS_BIDDER }}</p>
            <p>Town : {{ eib_info.POSTAL_ADDRESS_BIDDER }}</p>
            <p>Country : {{ eib_info.COUNTRY_BIDDER }}</p>
            <p>Legal Form : {{ eib_info.AA_AUTHORITY_TYPE }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6">
        <div class="card">
          <div
            class="card-header text-white"
            style="background-color: #ff6384"
            v-if="eib_info.crieib_cat === 'high risk'"
          >
            <div class="col-xl-6 col-lg-6">High Risk</div>
            <div class="col-xl-6 col-lg-6 text-right">
              <span class="badge badge-success">
                {{ cat_info["low risk"] }}
              </span>
              <span class="badge badge-warning"
                >{{ cat_info["medium risk"] }}
              </span>
              <span class="badge badge-danger">
                {{ cat_info["high risk"] }}
              </span>
            </div>
          </div>
          <div
            class="card-header text-white"
            style="background-color: #ffce56"
            v-if="eib_info.crieib_cat === 'medium risk'"
          >
            <div class="col-xl-6 col-lg-6">Medium Risk</div>
            <div class="col-xl-6 col-lg-6 text-right">
              <span class="badge badge-success">
                {{ cat_info["low risk"] }}
              </span>
              <span class="badge badge-warning"
                >{{ cat_info["medium risk"] }}
              </span>
              <span class="badge badge-danger">
                {{ cat_info["high risk"] }}
              </span>
            </div>
          </div>

          <div
            class="card-header text-white"
            style="background-color: #4bc0c0"
            v-if="eib_info.crieib_cat === 'low risk'"
          >
            <div class="col-xl-6 col-lg-6">Low Risk</div>
            <div class="col-xl-6 col-lg-6 texg-right">
              <span class="badge badge-success">
                {{ cat_info["low risk"] }}
              </span>
              <span class="badge badge-warning"
                >{{ cat_info["medium risk"] }}
              </span>
              <span class="badge badge-danger">
                {{ cat_info["high risk"] }}
              </span>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-xl-6 col-lg-6">
                <p>
                  <strong> CRI EIB TED: {{ eib_info.cri_eib_ted }} </strong>
                </p>
                <p>Single Bidder: {{ eib_info.singleb }}</p>
                <p>
                  No call for tenders publication: {{ eib_info.corr_nocft }}
                </p>
                <p>Risk Procedure type: {{ eib_info.corr_proc }}</p>
                <p>Risk Decision period: {{ eib_info.corr_decp }}</p>
                <p>Risk Submission period: {{ eib_info.corr_subm_p }}</p>
              </div>
              <div class="col-xl-6 col-lg-6">
                <p>&nbsp</p>
                <p>
                  Risk Length of eligibility criteria: {{ eib_info.corr_ecrit }}
                </p>
                <p>
                  Risk Length of product description: {{ eib_info.corr_descrl }}
                </p>
                <p>Non-cooperative jurisdictions: {{ eib_info.ncj }}</p>
                <p>Supplier Capture : {{ eib_info.wshare_total_winrmax }}</p>
                <p>Buyer Capture : {{ eib_info.wshare_total_anbmax }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            Tenders
            <hr />
          </div>
          <div class="card-body">
            <p>Savings : {{ eib_info.savings }}</p>
            <p>Number of contracts : {{ eib_info.nrc }}</p>
            <p>Total Value of Contracts : {{ eib_info.cv }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            <a v-if="eib_info.dedup_id_buyer">
              Top Bidders
              <hr
            /></a>
            <a v-else> Top Buyers </a>
          </div>
          <div class="card-body">
            <ul v-for="item in res_top">
              {{
                item._id
              }}
              :
              {{
                item.val
              }}
              €
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="eib_info">
      <div class="col-xl-6 col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            <div class="d-flex justify-content-between align-items-center">
              <span>Volume</span>
              <div class="justify-content-between">
                <input
                  class="mr-1"
                  type="checkbox"
                  id="scales"
                  :checked="selected_volume === 'contract_value'"
                  @change="updateBar('contract_value')"
                />
                <label for="scales">Contract Value</label>
                <input
                  class="mr-1 ml-2"
                  type="checkbox"
                  id="horns"
                  :checked="selected_volume === 'num_contrat'"
                  @change="updateBar('num_contrat')"
                />
                <label for="horns">Number of Contracts</label>
              </div>
            </div>
            <hr />
          </div>
          <div class="card-body">
            <div class="bar-chart-wrapper" v-if="isLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="bar-chart-wrapper" v-else>
              <canvas id="Bar1"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            Score Evolution
            <hr />
          </div>
          <div class="card-body">
            <div class="bar-chart-wrapper" v-if="isLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="bar-chart-wrapper" v-else>
              <br />
              <canvas id="Line1"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <span> Tenders </span>
              <button
                v-if="tableData && tableData.length"
                @click="csvExport(tableData)"
                class="btn btn-black"
                type="button"
              >
                <i class="fa fa-download"></i>
              </button>
            </div>
            <hr />
          </div>
          <div class="card-body" v-if="(tableData || []).length">
            <div class="row">
              <table-component :columns="columns" :data="tableData">
                <template slot="CFT_URL" slot-scope="{ row }">
                  <a :href="`${row.CFT_URL}`"> {{ row.CFT_URL }} </a>
                </template>
                <template slot="CA_URL" slot-scope="{ row }">
                  <a :href="`${row.CA_URL}`"> {{ row.CA_URL }} </a>
                </template>
                <template slot="CA_contract_value_in_EUR" slot-scope="{ row }">
                  <div align="right">{{ row.CA_contract_value_in_EUR }}</div>
                </template>
              </table-component>
            </div>
          </div>
          <div class="card-body" v-else>
            <a> No result found </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h1 v-else>EIB not found</h1>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "Explore",
  data() {
    return {
      baseUrl: `${BASE_URL}api/overview/explore/`,
      eib: this.$route.params.eib,
      tableData: [],
      createdCharts: [],
      data: [],
      labels: [],
      sum: [],
      avg: 0,
      eib_info: [],
      cat_info: [],
      global_gauge: {},
      sector_gauge_1: {},
      sector_gauge_2: {},
      res_bar: {},
      res_line: {},
      res_top: {},
      query: "",
      cat: "",
      country: 0,
      test: false,
      selected_volume: "contract_value",
      isLoading: false,
      cpv: 0,
      barChart: null,
      cpv_country: 0,
      columns: [
        "CFT_URL",
        "CFT_Date",
        "CA_URL",
        "CA_Date",
        "Buyer_Name",
        "Bidder_Name",
        "cri_eib_ted",
        "single_bidder",
        "no_call_for_tenders",
        "risk_procedure",
        "risk_decision_period",
        "risk_submission_period",
        "risk_length_criteria",
        "risk_length_product",
        "ncj",
        "savings",
        "procedure_type",
        "number_of_bids",
        "CA_contract_value_in_EUR",
        "elig_crit_length_in_LETTERS",
        "description_length_in_LETTERS",
        "submission_period_length_in_DAYS",
        "decision_period_length_in_DAYS",
      ],
    };
  },
  async mounted() {
    await this.initialize();
    this.makeGauge(this.global_gauge.avg, "Gauge2");
    this.makeGauge(this.global_gauge.country, "Gauge3");
    this.makeGauge(this.global_gauge.cri_eib, "Gauge1");
    this.makeGauge(this.sector_gauge_1.cpv, "Gauge4");
    this.makeGauge(this.sector_gauge_2.cpv_country || this.sector_gauge_2.cpv, "Gauge5");
    this.makeBar(this.res_bar.labels, "Bar1");
    this.makeLine(this.res_line.labels, "Line1");
  },
  methods: {
    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,\ufeff";
      csvContent += [
        Object.keys(arrData[0]).join(";"),
        ...arrData.map((item) => Object.values(item).join(";")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "eib_search_extract.csv");
      link.click();
    },
    async initialize() {
      this.isLoading = true;
      this.eib_info = (
        await this.$request({ url: `${this.baseUrl}${this.eib}` })
      ).data;
      this.cat_info = (
        await this.$request({
          url: `${BASE_URL}api/overview/cat_eib/${this.eib_info["counterpart_type"]}`,
        })
      ).data;
      let typ;
      let eib_id;
      console.log(this)
      if (this.eib_info["counterpart_id"] !== null && this.eib_info["counterpart_id"] !== "") {
        typ = this.eib_info["counterpart_type"];
        eib_id = this.eib_info["counterpart_id"];
        this.tableData = (
          await this.$request({
            url: `${this.baseUrl}table/` + eib_id + `/counterpart_id/` + typ,
          })
        ).data;
        this.global_gauge = (
          await this.$request({
            url:
              `${this.baseUrl}global/gauge/` +
              eib_id +
              `/counterpart_id/` +
              typ,
          })
        ).data;
        this.sector_gauge_1 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_first/gauge/` +
              eib_id +
              `/counterpart_id/` +
              typ,
          })
        ).data;
        this.sector_gauge_2 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_second/gauge/` +
              eib_id +
              `/counterpart_id/` +
              typ,
          })
        ).data;
        this.res_bar = (
          await this.$request({
            url: `${this.baseUrl}bar/` + eib_id + `/counterpart_id/` + typ,
          })
        ).data;
        this.res_line = (
          await this.$request({
            url: `${this.baseUrl}line/` + eib_id + `/counterpart_id/` + typ,
          })
        ).data;
        this.res_top = (
          await this.$request({
            url: `${this.baseUrl}top/` + eib_id + `/counterpart_id/` + typ,
          })
        ).data;
        this.isLoading = false;
      } else if (this.eib_info["dedup_id_buyer"] !== null && this.eib_info["dedup_id_buyer"] !== "")       {
        eib_id = this.eib_info["dedup_id_buyer"];
        this.tableData = (
          await this.$request({
            url: `${this.baseUrl}table/` + eib_id + `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.global_gauge = (
          await this.$request({
            url:
              `${this.baseUrl}global/gauge/` + eib_id + `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.sector_gauge_1 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_first/gauge/` +
              eib_id +
              `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.sector_gauge_2 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_second/gauge/` +
              eib_id +
              `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.res_bar = (
          await this.$request({
            url: `${this.baseUrl}bar/` + eib_id + `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.res_line = (
          await this.$request({
            url: `${this.baseUrl}line/` + eib_id + `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.res_top = (
          await this.$request({
            url: `${this.baseUrl}top/` + eib_id + `/dedup_id_buyer/buyer`,
          })
        ).data;
        this.isLoading = false;
      } else {
        eib_id = this.eib_info["dedup_id_bidder"];
        this.tableData = (
          await this.$request({
            url: `${this.baseUrl}table/` + eib_id + `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.global_gauge = (
          await this.$request({
            url:
              `${this.baseUrl}global/gauge/` +
              eib_id +
              `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.sector_gauge_1 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_first/gauge/` +
              eib_id +
              `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.sector_gauge_2 = (
          await this.$request({
            url:
              `${this.baseUrl}sector_second/gauge/` +
              eib_id +
              `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.res_bar = (
          await this.$request({
            url: `${this.baseUrl}bar/` + eib_id + `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.res_line = (
          await this.$request({
            url: `${this.baseUrl}line/` + eib_id + `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.res_top = (
          await this.$request({
            url: `${this.baseUrl}top/` + eib_id + `/dedup_id_bidder/bidder`,
          })
        ).data;
        this.isLoading = false;
      }
    },
    updateBar(volume) {
      this.selected_volume = volume;
      this.makeBar();
    },
    makeGauge(data, chartId) {
      const color = this.getColor(data);
      const options = {
        type: "pie",
        data: {
          datasets: [
            {
              data: [data, 1 - data],
              backgroundColor: [color, "#DCDCDC"],
              borderWidth: 0,
            },
          ],
        },
        options: {
          cutoutPercentage: 70,
          responsive: true,
          circumference: Math.PI,
          rotation: -Math.PI,
          tooltips: false,
          aspectRatio: 1.5,
        },
      };
      const ctx = document.getElementById(chartId).getContext("2d");
      new Chart(ctx, options);
    },
    makeBar() {
      const chartId = "Bar1";
      const labels = this.res_bar.labels;
      const value = this.selected_volume === 'num_contrat'
        ? this.res_bar.count
        : this.selected_volume === 'contract_value'
          ? this.res_bar.sum
          : [];
      const options = {
        type: "bar",
        data: {
          labels: labels,
          datasets: value,
        },
        options: {
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value, index, values) {
                    return value.toLocaleString("fr-FR");
                  },
                },
                scaleLabel: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      };
      const ctx = document.getElementById(chartId).getContext("2d");
      if (this.barChart) {
        this.barChart.destroy();
      }
      this.barChart = new Chart(ctx, options);
    },
    makeLine() {
      const chartId = "Line1";
      const labels = this.res_line.labels;
      const value = this.res_line.datasets;
      const options = {
        type: "line",
        data: {
          labels: labels,
          datasets: value,
        },
        options: {
          legend: {
            display: true,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                scaleLabel: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      };
      const ctx = document.getElementById(chartId).getContext("2d");
      if (this.lineChart) {
        this.lineChart.destroy();
      }
      this.lineChart = new Chart(ctx, options);
    },
    getColor(value) {
      if (value > 0.8) {
        return "#ff6384";
      } else if (value > 0.6) {
        return "#FF996D";
      } else if (value > 0.4) {
        return "#FFCE56";
      } else if (value > 0.2) {
        return "#a5C78B";
      } else {
        return "#4BC0C0";
      }
    },
  },
};
</script>

<style>
.card {
  border-radius: 20px;
}

.bar-chart {
  background-color: lightgrey;
  border-radius: 20px;
  padding: 10px;
  margin: 10px;
}

.bar-chart-wrapper {
  position: relative;
  height: 30vh;
  width: 97%;
}

.charts div {
  background-color: #f9f9f9;
  border-radius: 20px;
  flex: 1;
}

.charts h2 {
  color: #004494;
  text-align: center;
}

hr {
  margin: 10px 30px 0 !important;
  border: 1px solid black;
}

h1 {
  font-size: 40px;
}

h2 {
  font-size: 20px;
}

ul {
  padding: 0;
  list-style-type: none;
}
</style>
